module.exports = __webpack_public_path__ + "img/unproductive-apps-urls-reports.59a57933.webp";